import {
  createElement,
  useEffect,
  useRef,
  useState,
  type ReactElement,
} from "react";
import { Button } from "@zzk/ui";

const DEFAULT_THROTTLE_MS = 10_000;

export interface RefreshButtonProps {
  readonly onRefresh: () => void | Promise<void>;
  readonly throttleMs?: number;
  readonly disabled?: boolean;
}

export function RefreshButton(props: RefreshButtonProps): ReactElement {
  const [busy, setBusy] = useState(false);
  const [cooldown, setCooldown] = useState(false);
  const cooldownTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const throttle = props.throttleMs ?? DEFAULT_THROTTLE_MS;

  useEffect(() => {
    return () => {
      if (cooldownTimer.current) clearTimeout(cooldownTimer.current);
    };
  }, []);

  async function onClick() {
    if (busy || cooldown || props.disabled) return;
    setBusy(true);
    try {
      await props.onRefresh();
    } finally {
      setBusy(false);
      setCooldown(true);
      if (cooldownTimer.current) clearTimeout(cooldownTimer.current);
      cooldownTimer.current = setTimeout(() => {
        setCooldown(false);
        cooldownTimer.current = null;
      }, throttle);
    }
  }

  return createElement(
    Button,
    {
      type: "button",
      variant: "secondary",
      size: "sm",
      onClick,
      loading: busy,
      loadingLabel: "Atualizando…",
      disabled: busy || cooldown || props.disabled,
    },
    cooldown ? "Atualizar (aguarde)" : "Atualizar",
  );
}
